import { SVGProps } from "react";

export function FileUploadPlaceholderIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="53"
      height="52"
      fill="none"
      viewBox="0 0 53 52"
      {...props}
    >
      <g clipPath="url(#clip0_3256_3740)">
        <path
          fill="#D0D5DD"
          d="M.5 10.4c0-2.86 2.34-5.2 5.2-5.2h41.6a5.2 5.2 0 015.2 5.2v31.2a5.2 5.2 0 01-5.2 5.2H5.7a5.2 5.2 0 01-5.2-5.2V10.4zm28.6 23.4L21.3 26 5.7 41.6h41.6l-13-13-5.2 5.2zm10.4-10.4a5.2 5.2 0 100-10.4 5.2 5.2 0 000 10.4z"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_3256_3740">
          <path fill="#fff" d="M0 0H52V52H0z" transform="translate(.5)"></path>
        </clipPath>
      </defs>
    </svg>
  );
}
